export default "__VITE_ASSET__DKBqTrz3__"